import React from 'react';
import { useEffect } from 'react'

function NotFound() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>

      <div className='mx-auto text-center max-w-prose my-24 xl:my-36 px-8'>

        <div className=' text-black my-24 xl:my-36'>

          <p className="text-6xl font-gotham  mb-4">
            404
          </p>
          <p className="text-3xl font-gotham">
            This page does not exist. <br></br>Try again?
          </p>
        </div>

      </div>

    </>
  );
}

export default NotFound;
